import { Component, Input, inject } from '@angular/core';
import { LDWDocument } from '../../shared/models/LDWDocument';
import { DocumentService } from '../../shared/services/document.service';
import { DocumentHistory } from '../../shared/models/document-history';
import { TranslateService } from '@ngx-translate/core';
import { LdwRouterService } from '../../route/ldw-router.service';

@Component({
    selector: 'ldw-pdf-history-viewer',
    templateUrl: './pdf-history-viewer.component.html',
    styleUrls: ['./pdf-history-viewer.component.css'],
    standalone: false
})
export class PdfHistoryViewerComponent {
  private documentService = inject(DocumentService);
  private translateService = inject(TranslateService);
  private routerService = inject(LdwRouterService);


  private _document: LDWDocument | undefined = undefined;
  private _history: DocumentHistory | undefined = undefined;
  blob: Blob = new Blob();
  private oldid = '';
  private oldFileName = '';

  @Input() printAllowed = false;
  @Input() downloadAllowed = false;

  @Input()
  get document(): LDWDocument | undefined {
    return this._document;
  }

  set document(value: LDWDocument | undefined) {
    if (this._document == value) {
      return;
    }
    this._document = value;
    this.loadDocumentPdf();
  }

  @Input()
  get history(): DocumentHistory | undefined {
    return this._history;
  }

  set history(value: DocumentHistory | undefined) {
    if (this._history == value) {
      return;
    }
    this._history = value;
    this.loadDocumentPdf();
  }

  get selectedLanguage() {
    return this.translateService.currentLang;
  }

  loadDocumentPdf() {
    if (this._document == undefined || this._document.id == undefined || this._history == undefined) {
      return;
    }
    if (this._document.id == this.oldid && this._history.fileName == this.oldFileName) {
      return;
    }
    this.oldid = this._document.id;
    this.oldFileName = this._history.fileName;

    this.documentService.getHistoryPdf(this.oldid, this.oldFileName).subscribe(
      res => {
        this.blob = res;
      }
    );
  }
  pageChanged($event:any){
    this.routerService.setQueryParams('page', $event ?? '1')
  }

  zoomChanged($event:any){
    this.routerService.setQueryParams('zoom', $event ?? '1')
  }

}
